// removed by extract-text-webpack-plugin
module.exports = {"buttonToolbarDropdown":"Emd4pY_2B5az6nMFom3_i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownMenu/styles.css
// module id = 2935
// module chunks = 0